export const MIN_PAGE_WIDTH = 320;
export const MAX_PAGE_WIDTH = 1170;
export const PAGE_WIDTH = 1140;
export const NAVBAR_HEIGHT = 69;
export const HEADER_NOTICE_HEIGHT = 94;
